export const RiskFactors = [
  "10 y T Implied Vol",
  "10 Year Treasury",
  "3 Mo Libor",
  "5Year US Cap Imp Vol",
  "5yr Credit Spread BBB - AAA Industrial",
  "Change in Vix",
  "Goldman Sachs Commodity-Agriculture",
  "Goldman Sachs Commodity-Energy",
  "Goldman Sachs Commodity-Prec. Metals",
  "High Yield vs 10 yr Treasury",
  "Industrial A Credit vs 10 Yr Treasury",
  "MSCI ACWI xUSA",
  "Nasdaq",
  "S&P 500",
  "Spread between 2Y and 10Y Treasury",
  "Spread between 3Mo and 2Y Treasury",
  "Vol FTSE",
];

export const InvestmentOrder = [
  "IAM Absolute Return",
  "IAM Cash",
  "IAM Domestic Equity",
  "IAM Fixed Income",
  "IAM International Equity",
  "IAM Private Equity",
  "IAM Real Estate",
];

export const Betas = {
  "IAM Absolute Return": [
    -0.346739530563, 1.15194988251, -2.66064858437, -0.14349155128,
    -2.8915746212, -0.021018313244, -0.0714995712042, 0.0524385198951,
    0.0526994876564, -0.983869791031, -2.17189979553, 0.263009518385,
    0.0999395027757, 0.196028903127, -0.934760332108, 2.03247666359,
    -0.204352810979,
  ],
  "IAM Cash": [
    -0.0293664913625, 0.0629053264856, 0.0530004501343, -0.00875047687441,
    0.269518524408, 0.0031842214521, -0.00185775791761, 0.00177687883843,
    -0.00241073174402, 0.0965637788177, 0.310012727976, -0.0109407845885,
    -0.00705785676837, -0.00486884545535, -0.132595509291, -0.103725522757,
    0.00413071317598,
  ],
  "IAM Domestic Equity": [
    -0.191158592701, 0.0796694383025, 0.0575185902417, -0.0112182283774,
    -1.71692717075, -0.144262656569, 0.142360344529, -0.0294134411961,
    -0.0346374362707, -0.430336266756, -2.10795259476, 0.561123847961,
    0.491624295712, 0.953528881073, -0.172696068883, 0.145751923323,
    -0.100499160588,
  ],
  "IAM Fixed Income": [
    -0.0751154720783, 0.000334954704158, 0.0301227681339, 0.0164286829531,
    0.594018340111, -0.00381163344719, 0.000904585176613, 0.000854921585415,
    0.08222677559, 0.150710090995, 0.15722244978, 0.0436106435955,
    0.015988105908, 0.0679870694876, 0.0198958907276, -0.501574397087,
    0.0103869056329,
  ],
  "IAM International Equity": [
    -0.342585414648, -0.206011250615, -0.175133377314, 0.0265386104584,
    -1.32198905945, -0.118787482381, 0.0901569873095, -0.00165834126528,
    0.207808077335, -0.647374093533, -2.55592274666, 0.951716244221,
    0.418287932873, 0.780683457851, 0.288591116667, 0.179557710886,
    -0.122868955135,
  ],
  "IAM Private Equity": [
    -0.314656615257, -0.0141093963757, 0.0991351827979, -0.0844461247325,
    -3.70382428169, 0.0153308128938, -0.0381234101951, 0.023025104776,
    0.0169018562883, -0.477812707424, -1.25843405724, -0.0278131719679,
    -0.0403515286744, -0.0456860736012, -0.627612113953, -0.0546472333372,
    -0.0339056812227,
  ],
  "IAM Real Estate": [
    -0.275960892439, -0.191233500838, 0.00673980312422, -0.034311350435,
    -1.72704720497, -0.0172025989741, 0.0343318171799, -0.00891612563282,
    0.00151022581849, -0.35812291503, -0.271771132946, 0.0622267685831,
    0.0232724901289, 0.0655261650681, -0.461660414934, -0.340335905552,
    -0.0246815104038,
  ],
};

export const DefinedBenefitWeights = [
  0.107330428436, -0.0476051039565, 0.337284721543, 0.246169820025,
  0.191837209215, 0.0550400197612, 0.109942904978,
];

export const HistoricalScenarios = {
  "2008 Credit Crisis": [
    0.370000004768, 0, 0, 0.550000011921, 0, 0.647499978542, 0, 0, 0,
    0.219999998808, 0.0649999976158, -0.550000011921, -0.5, -0.40000000596, 0,
    0, 0.449999988079,
  ],
  "Black Monday": [
    0, 0, 0, 0, 0.0056, 0.7, 0, 0, 0, 0.056, 0.0152, -0.17, -0.35, -0.217, 0, 0,
    0,
  ],
  "DotCom Bubble Burst": [
    0.07, 0, 0, 0.09, 0, 0.2, 0, 0, 0, 0.16, 0.025, -0.38, -0.67, -0.4, 0, 0,
    0.2,
  ],
  Inflation2021: [
    0.386, 0, 0, 0.09, 0, 0.36, 0, 0, 0, 0.02, 0.007, -0.27, -0.36, -0.254, 0,
    0, 0.2,
  ],
  Inflation70s: [
    0.13, 0.07, 0.06, 0.61, 0, 0.19, 0, 0, 0, 0.0556, 0.0233, -0.35, -0.4,
    -0.22, 0, 0, 0.29,
  ],
  "September11 Terror Attacks": [
    0.08, 0, 0, 0.08, 0, 0.2, 0, 0, 0, 0.08, 0.014, -0.12, -0.1, -0.12, 0, 0, 0,
  ],
  "Small Cap Worries2H02": [
    0.072, 0, 0, 0.115, 0, 0.082, 0, 0, 0, 0.0014, 0.007, -0.052, -0.081, -0.07,
    0, 0, 0.155,
  ],
  "SVB - CSFB Collapse": [
    -0.033, 0, 0, 0.09, 0, 0.265, 0, 0, 0, 0.033, 0.016, -0.067, -0.09, -0.072,
    0, 0, 0.266,
  ],
};
